<template>
  <div style="padding: 30px;">
    <el-form
      v-if="showTable"
      ref="form"
      :rules="rules"
      :model="form"
      label-width="100px"
    >
      <el-form-item v-if="isService" label="选择账户" prop="actId">
        <el-cascader
          v-model="company"
          style="max-width:99%;"
          :options="authorizeCompanyOptions"
          @change="handleCompany"
        />
        <!-- <el-select v-model="form.actId" placeholder="请选择" filterable @change="handleChangeActId">
          <el-option-group v-for="item in authorizeCompanyOptions" :key="item.csiId" :label="item.companyName">
            <el-option v-for="item1 in item.accountList" :key="item1.actId" :label="item1.fuelType" :value="item1.actId" />
          </el-option-group>
        </el-select> -->
      </el-form-item>
      <el-form-item label="运费金额">
        <el-input v-model="row.deliveryFeeDeserved" disabled />
      </el-form-item>
      <el-form-item label="托运人已付金额">
        <el-input v-model="row.allotTaxAmount" disabled />
      </el-form-item>
      <el-form-item label="已预付油点">
        <el-input v-model="row.payOil" disabled />
      </el-form-item>
      <el-form-item label="已预付金额">
        <el-input v-model="row.payAmount" disabled />
      </el-form-item>
      <el-form-item label="预付油点" prop="amount">
        <el-input
          v-model="form.amount"
          placeholder="请输入预付油点"
          @input="
            value => formFormatter.isFloor2(value, oldValue, form, 'amount')
          "
          @mousewheel.native.prevent
        />
      </el-form-item>
      <el-form-item v-if="isService" label="分配账户品类" prop="category">
        <el-input v-model="row.fuelType" disabled />
      </el-form-item>
    </el-form>
    <div v-if="showTable" slot="footer" class="dialog-footer">
      <el-button type="primary" @click="payclick('form')">预付</el-button>
    </div>
  </div>
</template>
<script>
import { payAdvanceOilCard } from "@/api/CustomerService";
import { getAuthorizeCompany } from "@/api/userOil";
import { mayDecimal } from "@/utils/validate4Form.js";
export default {
  data() {
    return {
      company: "",
      row: {},
      form: {
        actId: "",
        payType: 1,
        amount: "",
        orderDetailCode: "",
        payerCode: "",
        payeeCode: "",
        category: "1"
      },
      rules: {
        amount: [
          { required: true, message: "请输入预付油点", trigger: "blur" },
          { validator: mayDecimal, trigger: "blur" }
        ],
        actId: [{ required: true, message: "请选择账户", trigger: "change" }]
      },
      // categoryOptions:[
      //   { value:'1', label: '柴油' },
      //   { value:'2', label: '天然气' }
      // ],
      authorizeCompanyOptions: [],
      fuelTypeObj: {},
      actIdObj: {},
      isService: false,
      showTable: false
    };
  },
  created() {},
  methods: {
    setFee(row) {
      this.showTable = false;
      this.getAuthorizeCompany(row.branchCode);
      this.form.amount = "";
      this.row = row;
      this.form.orderDetailCode = row.code;
      this.form.payerCode = row.shipmentCode;
      this.form.payeeCode = row.driverCode;
      this.form.category = "1";
      this.form.actId = "";
      this.form.authorizeCuId = "";
      this.form.authorizeZzNumber = "";
      this.company = "";
    },
    payclick(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          const rLoading = this.openLoading();
          payAdvanceOilCard(this.form).then(response => {
            this.$emit("closeWindows");
            rLoading.close();
            this.$message({
              message: response.msg,
              type: "success"
            });
          });
        } else {
          //console.log("error submit!!");
          return false;
        }
      });
    },
    getAuthorizeCompany(branchCode) {
      const rLoading = this.openLoading();
      this.authorizeCompanyOptions = [];
      return getAuthorizeCompany({
        page: 1,
        pageSize: 500,
        receiptCode: "",
        branchCode: branchCode
      })
        .then(response => {
          let data = response.data;
          this.isService = data.isService;
          data.authorizeCompanyList.forEach(item => {
            let obj = {
              value: item.zzNumber,
              label: item.companyName
            };
            if (item.accountList) {
              let children = [];
              item.accountList.forEach(account => {
                children.push({
                  value: account.cuId,
                  label: account.fuelType,
                  disabled: account.actId == ""
                });
                this.fuelTypeObj[account.cuId] = account.fuelType;
                this.actIdObj[account.cuId] = account.actId;
              });
              obj.children = children;
              this.authorizeCompanyOptions.push(obj);
            }
          });
          // this.authorizeCompanyOptions.forEach(item => {
          //   if(item.accountList) {
          //     item.accountList.forEach(account => {
          //       this.fuelTypeObj[account.actId] = account.fuelType
          //     })
          //   }
          // })
        })
        .finally(() => {
          this.showTable = true;
          rLoading.close();
        });
    },
    handleCompany(value) {
      this.form.authorizeZzNumber = value[0];
      this.form.authorizeCuId = value[1];
      this.form.actId = this.actIdObj[value[1]];
      this.row.fuelType = this.fuelTypeObj[value[1]];
    }
    // handleChangeActId(val) {
    //   this.row.fuelType = this.fuelTypeObj[val]
    // }
  }
};
</script>

<style lang="scss" scoped>
.dialog-footer {
  float: right;
}
</style>
